var msg = new Array();
msg['ERR_PRIVACY']='Vous devez accepter les conditions';
msg['ERR_MISSINGFIELDS']='Remplissez correctement tous les champs obligatoires';
msg['ERR_FILLEMAILFIELD']='Remplissez le champ email';
msg['ERR_USEREXISTS']='L\'adresse email est déjà enregistrée. Veuillez vous connecter';
msg['ERR_INVALIDMAIL']='Email non valide';
msg['ERR_CLIENTMANDATORYFIELDS']='Les champs marqués sont obligatoires';
msg['ERR_NOSIZESELECTED']='Vous devez d\'abord sélectionner une taille';
msg['ERR_LOGINREQUIRED']='Vous devez vous connecter';
msg['ERR_LOGININVALID']='Email ou mot de passe invalide';
msg['ERR_CONFIRMPASSWORD']='Les mots de passe ne correspondent pas';
msg['ERR_MINLENGTH']='Doit contenir au moins :length caractères';
msg['ERR_CARRIERMISSING']='Vous devez sélectionner un mode de livraison';
msg['ERR_CARRIER_COST_MISSING']='Aucun tarif applicable pour le pays, le transporteur et le poids de la commande';
msg['ERR_FILE_TOO_LARGE']='Le fichier téléchargé est trop volumineux, la taille maximale est :size';
msg['ERR_MIN_LENGTH']='Le champ :field doit contenir au moins :length caractères';
msg['ERR_PEC_OR_SDI_REQUIRED']='Remplissez au moins un champ entre PEC et SDI';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Seule la réservation de la commande sera activée et les frais de livraison seront communiqués par email';
msg['MSG_REMOVEDFROMCART']='Produit supprimé du panier';
msg['MSG_DELETEALLPRODUCTS']='Êtes-vous sûr de vouloir supprimer tous les produits du panier?';
msg['DELETEALLPRODUCTSERROR']='Erreur de suppression des produits du panier';
msg['MSG_ADDEDTOCART']='Produits ajoutés au panier';
msg['MSG_WAIT']='Veuillez patienter...';
msg['MSG_SUBJECT_PRODUCT_SHARE']=' a partagé quelque chose avec vous';
msg['MSG_SENDER_PRODUCTSHARE']='Votre nom';
msg['MSG_MESSAGE_PRODUCTSHARE']='Message';
msg['MSG_MAILSENT']='E-mails envoyés';
msg['MSG_MIXED_INTANGIBLE']='Les produits dans le panier ne peuvent pas être achetés ensemble avec le produit sélectionné';
msg['MSG_MIXED_CART']='Les produits dans le panier ne peuvent pas être achetés ensemble avec le produit sélectionné car ils se trouvent dans des entrepôts différents';
msg['MSG_INSUFFICIENT_STOCK']='Actuellement la disponibilité du produit n\'est pas suffisante';
msg['MSG_APPLIEDVATCHANGED']='Après cette mise à jour des données de facturation, la TVA appliquée à votre commande a changé';
msg['MSG_GENERIC_ERROR']='Désolé, une erreur est survenue';
msg['MSG_COUPON_ERROR']='Code coupon invalide ou déjà saisi';
msg['MSG_COUPON_VALID']='Code coupon saisi validé avec succès';
msg['MSG_RECOVEREMAILSENT']='Vérifiez votre email et insérez le code pour confirmer la modification';
msg['MSG_RECOVEREMAILSENT_ERROR']='Attention: Vous n\'êtes pas enregistré avec cette adresse email ou vous réinitialisez déjà un nouveau mot de passe';
msg['MSG_EXTRAUELIMIT']='Le montant minimum de votre commande ne peut pas être inférieur à 2000.00 &euro;';
msg['MSG_PASSWORDUPDATED']='Mot de passe mis à jour';
msg['MSG_RULE_REJECT']='Le produit ne peut pas être ajouté au panier à cause de la règle :rule';
msg['LABEL_ARTICLES']='articles';
msg['LABEL_WARNING']='Attention';
msg['LABEL_NOTAPPLICABLE']='Non applicable';
msg['LABEL_ALREADYREGISTEREDUSERES']='Utilisateurs déjà enregistrés';
msg['LABEL_SENTINVITES']='Invitations envoyées';
msg['LABEL_NOTSENTINVITES']='Invitations non envoyées';
msg['LABEL_INVITES_ALREADY_SENT']='Utilisateurs déjà invités';
msg['LABEL_SUBMIT']='Envoyer';
msg['LABEL_SELECTALL']='Tout sélectionner';
msg['MSG_MESSAGE_SENT']='Message envoyé!';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Demande de retour créée avec succès';
msg['MSG_RETURN_REQUEST_ALREADY_EXISTS'] = 'Demande de retour déjà effectuée';
msg['MSG_SAVE_SUCCESS'] = 'Sauvegarde réussie';
msg['MSG_SUBSCRIBED'] = 'Abonné avec succès';
msg['MSG_PROFILECONSENT_SAVED'] = 'Vos préférences de contact ont été mises à jour';
msg['MSG_SAMPLE_NOT_FOUND']='Aucun échantillon n\'a été trouvé pour le produit choisi';
msg['MSG_NEWSLETTER_COMPLETED']='Inscription effectuée avec succès';
msg['MSG_INVALID_CAPTCHA'] ='Code captcha non valide';
msg['MSG_USER_ALREADY_REGISTERED'] ='Utilisateur déjà enregistré';
msg['MSG_CONFIRM_BOOKING'] = "Confirmez-vous vouloir payer par virement bancaire?";
msg['MSG_CONFIRM_COD'] = "Confirmez-vous vouloir payer à la livraison?";
msg["MSG_CONFIRM_CART_RESET"] = "Êtes-vous sûr de vouloir créer un nouveau panier ?";
msg["ERR_CART_RESET"] = "Une erreur s'est produite lors de la réinitialisation du panier. Essayez de vider le panier manuellement.";
msg['MSG_PASSWORD_OK'] ='Le mot de passe a été réinitialisé avec succès';
msg['msg.order.expiredcart'] ='Le panier a expiré';
msg['msg.order.missingquantities'] ='Un ou plusieurs produits ne sont pas disponibles dans la quantité demandée ou pour le pays de livraison sélectionné';
msg['A reset email has already been sent.']='Email de récupération de mot de passe déjà envoyé';
msg['No user found']='Utilisateur non trouvé';
msg['Procedura di recupero password non abilitata per utenti non attivi.']='Procédure de récupération de mot de passe non activée pour les utilisateurs inactifs';
msg['msg.form.invalidtype'] = 'Une erreur est survenue. Contactez l\'administration en rapportant ce qui suit: "Type de contact non valide ou manquant."';
msg['msg.form.invalidemail'] = 'Email non valide ou manquant';
msg['msg.form.invalidrecipients'] = 'Une erreur est survenue. Contactez l\'administration en rapportant ce qui suit: "Destinataires de contact non valides ou manquants."';
msg['login.user.unexisting']='L\'utilisateur n\'existe pas';

var portal_livestock_available='DISPONIBLE';
var portal_livestock_soldout='ÉPUISÉ';

var activity_online_shop = 'boutique en ligne';
var activity_shop = 'boutique';
var activity_private_sales = 'ventes privées';
var activity_outlet = 'outlet';
var activity_online_outlet = 'outlet en ligne';
var activity_store_chain = 'chaîne de boutiques';
var activity_purchasing_group = 'groupe d\'achat';
var activity_broker = 'courtier/agent';
var activity_ebay_amazon = 'boutique ebay/amazon';
var activity_other = 'autre';

var general="Général";
var general_personaldata='Données personnelles';
var general_olduser='Utilisateur enregistré';
var general_newuser='Nouvel utilisateur';
var general_username="Nom d'utilisateur";
var general_password="Mot de passe";
var general_contacts="Contacts";
var general_choosesize="Sélectionnez les options";
var general_phone="Téléphone";
var general_skype="Skype";
var general_website="WebSite";
var general_fax="Fax";
var general_firstname='Prénom';
var general_lastname='Nom';
var general_company='Entreprise';
var general_birth='Date de naissance';
var general_code='Code';
var general_model='Modèle';
var general_quantity='Quantité';
var general_availability='Disponibilité';
var general_price='Prix';
var general_warning='Attention';
var general_dispatchto='Destinataire';
var general_careof='À l\'attention de';
var general_vat='N° fiscal, N° TVA';
var general_address='Adresse';
var general_addresstype='Type d\'adresse';
var general_addressnumber='Numéro civique';
var general_city='Ville';
var general_prov='Province';
var general_zip='Code postal';
var general_mobile='Mobile';
var general_notes='Notes';
var general_orders='Commandes';
var general_fgfdiscounts='Amis et réductions';
var general_myprofile='Mon profil';
var general_pieces='pz';
var general_size_table='Tableau des tailles';
var general_details='Détails';
var general_invoice='Facture';
var general_creditnote='Note de crédit';
var general_cart= 'Panier';
var general_country='Pays';
var general_carrier='Transporteur';
var general_dispatch_address='Adresse de livraison';
var general_invoice_address='Adresse de facturation';
var general_receive_newsletter='Recevoir la Newsletter';
var general_copydispatchfrombilldata='Copier depuis les données de facturation';
var general_instructions="Instructions";
var general_add="Ajouter";
var general_status="Statut";
var general_toomanyfilters="Vous avez atteint le nombre maximum de filtres autorisés.";

var help_addresstype='Rue, Place, Avenue, ...';
var help_address='Entrez le nom de la rue';
var help_dispatchmobile='Entrez un numéro de téléphone sur lequel être contacté pour la livraison';
var help_ordercfpiva='En laissant ce champ vide, la TVA par défaut sera appliquée à la valeur de la commande';
var help_cf='Entrez votre numéro d\'identification fiscale (NIF)';

var buttons_save='Sauvegarder';
var buttons_changepw='Changer le mot de passe';
var buttons_close='Fermer';
var buttons_continue='Continuer';
var buttons_confirm='Confirmer';
var buttons_cancel='Annuler';
var buttons_invite='Inviter';
var buttons_continueshopping='Continuer les achats';
var buttons_gocheckout='Aller au panier';

var messages_product_soldout='Le produit est épuisé';
var messages_noselection='La sélection est vide';
var messages_invaliddata='Remplissez correctement tous les champs';
var messages_recoverpassword='Récupérer le mot de passe';
var messages_recoverpassword_info='Entrez l\'adresse email avec laquelle vous vous êtes enregistré. <br/>Un email vous sera envoyé avec les instructions pour définir un nouveau mot de passe';
var messages_invitefriends='Inviter des amis';
var messages_confirmpassword='Confirmer le mot de passe';
var messages_sendingmail='Envoi d\'email en cours...';
var messages_mailsent='Email envoyé avec succès';
var messages_password='Mot de passe';
var messages_confirmpassword='Confirmer le mot de passe';
var messages_requiredfield='Champ obligatoire';

var subscribe_personaldata='Traitement des données';
var subscribe_privacyintro='Pour procéder à l\'inscription, il est nécessaire de prendre connaissance de la réglementation sur la confidentialité et d\'autoriser le traitement des données personnelles';
var subscribe_privacydisclaimer='Vous devez accepter la politique de confidentialité pour terminer l\'inscription.'
var subscribe_privacy1='Le soussigné certifie avoir pris connaissance et accepté la politique de confidentialité';
var subscribe_privacy2='Le soussigné autorise la communication de ses données à des sociétés tierces pour des actions commerciales (facultatif)';

var order_status='Statut'
var order_date='Date'
var order_dispatchdate='Expédié';

var returnedgoods_requests="Demandes de retour";
var returnedgoods_motivations="Raison du retour";
var returnedgoods_requestcode="Code retour";
var returnedgoods_requestdate="Demandé le";
var returnedgoods_motivations_1="Le produit ne me convient pas";
var returnedgoods_motivations_2="Le produit est trop grand/petit";
var returnedgoods_motivations_3="Le produit est endommagé";
var returnedgoods_motivations_4="Le produit reçu ne correspond pas au produit commandé";
var returnedgoods_motivations_5="Le produit n\'est pas présent dans le colis";
var returnedgoods_motivations_other="Autre";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='En attente';
i18nOrderStatus[1]='En attente de paiement';
i18nOrderStatus[2]='Confirmé';
i18nOrderStatus[3]='Expédié';
i18nOrderStatus[4]='Livré';
i18nOrderStatus[5]='Réservé';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Annulé';
i18nOrderStatus[2001]='Erreur';
i18nOrderStatus[3001]='En traitement';
i18nOrderStatus[3002]='Prêt';

i18nOrderStatus[1000]='Paiement annulé';
i18nOrderStatus[2002]='Échec de la vérification du paiement';
i18nOrderStatus[2003]='Remboursé';
i18nOrderStatus[2005]='Rejeté';
i18nOrderStatus[3003]='Non expédiable';
i18nOrderStatus[5001]='Non autorisé';
i18nOrderStatus[5002]='Autorisé';
i18nOrderStatus[5003]='Dropshipping - Growing';
